<template>
    <div class="door-check-add">
        <div class="row">
            <div class="page-header">
                <div class="d-flex align-items-center">
                    <h2 class="page-header-title">
                        <router-link to="/bae-systems-reports">
                        BAE Systems Reports</router-link>
                        &raquo;
                        <span v-if="isEdit">
                            <router-link :to="{ name: 'bae-systems-report-view', params: {action: 'view', id: baeSystemsReport.site_bae_systems_report_id} }">
                                {{ baeSystemsReport.door_identifier }} | {{ baeSystemsReport.door_location }}
                            </router-link>
                             &raquo;
                        </span>
                        <span v-if="isEdit">
                                Edit BAE Systems Report
                        </span>
                        <span v-else> 
                            Add BAE Systems Report
                        </span>
                    </h2>
                </div>
            </div>
        </div>

        <form @submit.prevent="submit">
            <div class="form-body">
                <div style="display:none;">
                    <div class="col-lg-6 col-md-12"><input type="hidden" name="_method" value="POST"/></div>
                </div>
                <div class="form-body">

                    <div class="row">
                        <div class="col-sm-12 widget-20">
                            <div class="widget has-shadow">
                                <div class="widget-header bordered d-flex align-items-center section-header">
                                    <h2>Report Details</h2>
                                </div>
                                <div class="widget-body">
                                    
                                    <div class="form-group row d-flex align-items-center ">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('door_identifier')]"
                                                for="door_identifier">
                                            Door ID
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    name="door_identifier"
                                                    id="door_identifier"
                                                    :class="['form-control', getFieldClasses('door_identifier')]"
                                                    v-model="baeSystemsReport.door_identifier"
                                                    type="text"
                                                    maxlength="50"
                                                    class="form-control"
                                                    @blur="onFieldBlur('door_identifier')"
                                            />
                                            <div v-if="isErrorField('door_identifier')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center ">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('door_location')]"
                                                for="door_location">
                                            Building
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    name="door_location"
                                                    id="door_location"
                                                    :class="['form-control', getFieldClasses('door_location')]"
                                                    v-model="baeSystemsReport.door_location"
                                                    type="text"
                                                    maxlength="255"
                                                    class="form-control"
                                                    @blur="onFieldBlur('door_location')"
                                            />
                                            <div v-if="isErrorField('door_location')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center ">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('door_zone_floor')]"
                                                for="door_zone_floor">
                                            Zone Floor
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    name="door_zone_floor"
                                                    id="door_zone_floor"
                                                    :class="['form-control', getFieldClasses('door_zone_floor')]"
                                                    v-model="baeSystemsReport.door_zone_floor"
                                                    type="text"
                                                    maxlength="50"
                                                    class="form-control"
                                                    @blur="onFieldBlur('door_zone_floor')"
                                            />
                                            <div v-if="isErrorField('door_zone_floor')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center ">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('door_rating')]"
                                                for="door_rating">
                                            Fire Door Rating
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    name="door_rating"
                                                    id="door_rating"
                                                    :class="['form-control', getFieldClasses('door_rating')]"
                                                    v-model="baeSystemsReport.door_rating"
                                                    type="text"
                                                    maxlength="50"
                                                    class="form-control"
                                                    @blur="onFieldBlur('door_rating')"
                                            />
                                            <div v-if="isErrorField('door_rating')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center ">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('door_material')]"
                                                for="door_material">
                                            Door Material
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    name="door_material"
                                                    id="door_material"
                                                    :class="['form-control', getFieldClasses('door_material')]"
                                                    v-model="baeSystemsReport.door_material"
                                                    type="text"
                                                    maxlength="255"
                                                    class="form-control"
                                                    @blur="onFieldBlur('door_material')"
                                            />
                                            <div v-if="isErrorField('door_material')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center ">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('door_manufacturer')]"
                                                for="door_manufacturer">
                                            Door Manufacturer and Product Name
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    name="door_manufacturer"
                                                    id="door_manufacturer"
                                                    :class="['form-control', getFieldClasses('door_manufacturer')]"
                                                    v-model="baeSystemsReport.door_manufacturer"
                                                    type="text"
                                                    maxlength="255"
                                                    class="form-control"
                                                    @blur="onFieldBlur('door_manufacturer')"
                                            />
                                            <div v-if="isErrorField('door_manufacturer')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end']"
                                                for="inspection_date">
                                            Date Of Inspection
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <datepicker
                                                    v-model="baeSystemsReport.inspection_date"
                                                    format="dd/MM/yy"
                                                    input-class="form-control"
                                                    name="inspection_date"
                                                    id="inspection_date"
                                            ></datepicker>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center ">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('inspector_name')]"
                                                for="inspector_name">
                                            Tested by Who
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    name="inspector_name"
                                                    id="inspector_name"
                                                    :class="['form-control', getFieldClasses('inspector_name')]"
                                                    v-model="baeSystemsReport.inspector_name"
                                                    type="text"
                                                    maxlength="255"
                                                    class="form-control"
                                                    @blur="onFieldBlur('inspector_name')"
                                            />
                                            <div v-if="isErrorField('inspector_name')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center ">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('company')]"
                                                for="company">
                                            Company
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    name="company"
                                                    id="company"
                                                    :class="['form-control', getFieldClasses('company')]"
                                                    v-model="baeSystemsReport.company"
                                                    type="text"
                                                    maxlength="255"
                                                    class="form-control"
                                                    @blur="onFieldBlur('company')"
                                            />
                                            <div v-if="isErrorField('company')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center ">
                                        <label class="col-lg-4 form-control-label d-flex justify-content-lg-end"  for="comments">
                                            General Comments
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <textarea
                                                    class="form-control"
                                                    name="comments"
                                                    maxlength="4000"
                                                    id="comments"
                                                    rows="5"
                                                    v-model="baeSystemsReport.comments"
                                            ></textarea>
                                        </div>
                                    </div>

                                    <div class="form-group border-top">
                                        <h2 class="mt-4">Door Leaf</h2>

                                        <div class="form-group">
                                            <label class="form-control-label">
                                                Does the door leaf sit against the door stop, flush with the frame and is it free of distortion?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="leaf_qn_1-yes"
                                                        name="leaf_qn_1"
                                                        v-model="baeSystemsReport.leaf_qn_1"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="leaf_qn_1-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="leaf_qn_1-no"
                                                        name="leaf_qn_1"
                                                        v-model="baeSystemsReport.leaf_qn_1"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="leaf_qn_1-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="leaf_qn_1-na"
                                                        name="leaf_qn_1"
                                                        v-model="baeSystemsReport.leaf_qn_1"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="leaf_qn_1-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-control-label">
                                                If the door is veneered or lipped, is the glue still holding these products firmly in place?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="leaf_qn_2-yes"
                                                        name="leaf_qn_2"
                                                        v-model="baeSystemsReport.leaf_qn_2"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="leaf_qn_2-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="leaf_qn_2-no"
                                                        name="leaf_qn_2"
                                                        v-model="baeSystemsReport.leaf_qn_2"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="leaf_qn_2-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="leaf_qn_2-na"
                                                        name="leaf_qn_2"
                                                        v-model="baeSystemsReport.leaf_qn_2"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="leaf_qn_2-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-control-label">
                                                Is the door free from damage affecting its fire integrity?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="leaf_qn_3-yes"
                                                        name="leaf_qn_3"
                                                        v-model="baeSystemsReport.leaf_qn_3"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="leaf_qn_3-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="leaf_qn_3-no"
                                                        name="leaf_qn_3"
                                                        v-model="baeSystemsReport.leaf_qn_3"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="leaf_qn_3-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="leaf_qn_3-na"
                                                        name="leaf_qn_3"
                                                        v-model="baeSystemsReport.leaf_qn_3"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="leaf_qn_3-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div class="form-group border-top">
                                        <h2 class="mt-4">Door Frame</h2>

                                        <div class="form-group">
                                            <label class="form-control-label">
                                                Is the door frame firmly attached to the wall?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="frame_qn_1-yes"
                                                        name="frame_qn_1"
                                                        v-model="baeSystemsReport.frame_qn_1"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="frame_qn_1-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="frame_qn_1-no"
                                                        name="frame_qn_1"
                                                        v-model="baeSystemsReport.frame_qn_1"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="frame_qn_1-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="frame_qn_1-na"
                                                        name="frame_qn_1"
                                                        v-model="baeSystemsReport.frame_qn_1"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="frame_qn_1-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-control-label">
                                                If a planted door stop is present, is it firmly attached?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="frame_qn_2-yes"
                                                        name="frame_qn_2"
                                                        v-model="baeSystemsReport.frame_qn_2"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="frame_qn_2-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="frame_qn_2-no"
                                                        name="frame_qn_2"
                                                        v-model="baeSystemsReport.frame_qn_2"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="frame_qn_2-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="frame_qn_2-na"
                                                        name="frame_qn_2"
                                                        v-model="baeSystemsReport.frame_qn_2"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="frame_qn_2-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-control-label">
                                                Is the door to frame gap consistently 4mm or less?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="frame_qn_3-yes"
                                                        name="frame_qn_3"
                                                        v-model="baeSystemsReport.frame_qn_3"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="frame_qn_3-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="frame_qn_3-no"
                                                        name="frame_qn_3"
                                                        v-model="baeSystemsReport.frame_qn_3"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="frame_qn_3-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="frame_qn_3-na"
                                                        name="frame_qn_3"
                                                        v-model="baeSystemsReport.frame_qn_3"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="frame_qn_3-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-control-label">
                                                Is the door frame free from any damage affecting its fire integrity?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="frame_qn_4-yes"
                                                        name="frame_qn_4"
                                                        v-model="baeSystemsReport.frame_qn_4"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="frame_qn_4-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="frame_qn_4-no"
                                                        name="frame_qn_4"
                                                        v-model="baeSystemsReport.frame_qn_4"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="frame_qn_4-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="frame_qn_4-na"
                                                        name="frame_qn_4"
                                                        v-model="baeSystemsReport.frame_qn_4"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="frame_qn_4-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-control-label">
                                                Is the fire stopping around the doorframe still in place?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="frame_qn_5-yes"
                                                        name="frame_qn_5"
                                                        v-model="baeSystemsReport.frame_qn_5"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="frame_qn_5-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="frame_qn_5-no"
                                                        name="frame_qn_5"
                                                        v-model="baeSystemsReport.frame_qn_5"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="frame_qn_5-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="frame_qn_5-na"
                                                        name="frame_qn_5"
                                                        v-model="baeSystemsReport.frame_qn_5"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="frame_qn_5-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div class="form-group border-top">
                                        <h2 class="mt-4">Intumescent / Smoke / Acoustic Seals</h2>

                                        <div class="form-group">
                                            <label class="form-control-label">
                                                Are intumescent seals in place? (Including any grills and vents).
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="seals_qn_1-yes"
                                                        name="seals_qn_1"
                                                        v-model="baeSystemsReport.seals_qn_1"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="seals_qn_1-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="seals_qn_1-no"
                                                        name="seals_qn_1"
                                                        v-model="baeSystemsReport.seals_qn_1"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="seals_qn_1-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="seals_qn_1-na"
                                                        name="seals_qn_1"
                                                        v-model="baeSystemsReport.seals_qn_1"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="seals_qn_1-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-control-label">
                                                Are the seals free from damage?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="seals_qn_2-yes"
                                                        name="seals_qn_2"
                                                        v-model="baeSystemsReport.seals_qn_2"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="seals_qn_2-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="seals_qn_2-no"
                                                        name="seals_qn_2"
                                                        v-model="baeSystemsReport.seals_qn_2"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="seals_qn_2-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="seals_qn_2-na"
                                                        name="seals_qn_2"
                                                        v-model="baeSystemsReport.seals_qn_2"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="seals_qn_2-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-control-label">
                                                Are smoke seals free from paint or varnish?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="seals_qn_3-yes"
                                                        name="seals_qn_3"
                                                        v-model="baeSystemsReport.seals_qn_3"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="seals_qn_3-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="seals_qn_3-no"
                                                        name="seals_qn_3"
                                                        v-model="baeSystemsReport.seals_qn_3"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="seals_qn_3-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="seals_qn_3-na"
                                                        name="seals_qn_3"
                                                        v-model="baeSystemsReport.seals_qn_3"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="seals_qn_3-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-control-label">
                                                Are the seals well attached inside the groove in the frame or door leaf?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="seals_qn_4-yes"
                                                        name="seals_qn_4"
                                                        v-model="baeSystemsReport.seals_qn_4"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="seals_qn_4-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="seals_qn_4-no"
                                                        name="seals_qn_4"
                                                        v-model="baeSystemsReport.seals_qn_4"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="seals_qn_4-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="seals_qn_4-na"
                                                        name="seals_qn_4"
                                                        v-model="baeSystemsReport.seals_qn_4"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="seals_qn_4-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-control-label">
                                                Is the smoke seal in full contact with the door giving an effective seal?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="seals_qn_5-yes"
                                                        name="seals_qn_5"
                                                        v-model="baeSystemsReport.seals_qn_5"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="seals_qn_5-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="seals_qn_5-no"
                                                        name="seals_qn_5"
                                                        v-model="baeSystemsReport.seals_qn_5"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="seals_qn_5-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="seals_qn_5-na"
                                                        name="seals_qn_5"
                                                        v-model="baeSystemsReport.seals_qn_5"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="seals_qn_5-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div class="form-group border-top">
                                        <h2 class="mt-4">Hinges</h2>

                                        <div class="form-group">
                                            <label class="form-control-label">
                                                Is there a minimum of 3 hinges?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="hinges_qn_1-yes"
                                                        name="hinges_qn_1"
                                                        v-model="baeSystemsReport.hinges_qn_1"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="hinges_qn_1-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="hinges_qn_1-no"
                                                        name="hinges_qn_1"
                                                        v-model="baeSystemsReport.hinges_qn_1"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="hinges_qn_1-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="hinges_qn_1-na"
                                                        name="hinges_qn_1"
                                                        v-model="baeSystemsReport.hinges_qn_1"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="hinges_qn_1-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-control-label">
                                                Are all the screws in place and the correct size?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="hinges_qn_2-yes"
                                                        name="hinges_qn_2"
                                                        v-model="baeSystemsReport.hinges_qn_2"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="hinges_qn_2-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="hinges_qn_2-no"
                                                        name="hinges_qn_2"
                                                        v-model="baeSystemsReport.hinges_qn_2"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="hinges_qn_2-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="hinges_qn_2-na"
                                                        name="hinges_qn_2"
                                                        v-model="baeSystemsReport.hinges_qn_2"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="hinges_qn_2-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-control-label">
                                                Are the hinges free of metal fragments, oil leakage and signs of wear?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="hinges_qn_3-yes"
                                                        name="hinges_qn_3"
                                                        v-model="baeSystemsReport.hinges_qn_3"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="hinges_qn_3-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="hinges_qn_3-no"
                                                        name="hinges_qn_3"
                                                        v-model="baeSystemsReport.hinges_qn_3"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="hinges_qn_3-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="hinges_qn_3-na"
                                                        name="hinges_qn_3"
                                                        v-model="baeSystemsReport.hinges_qn_3"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="hinges_qn_3-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-control-label">
                                                Are the hinges free from non-intumescent packing?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="hinges_qn_4-yes"
                                                        name="hinges_qn_4"
                                                        v-model="baeSystemsReport.hinges_qn_4"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="hinges_qn_4-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="hinges_qn_4-no"
                                                        name="hinges_qn_4"
                                                        v-model="baeSystemsReport.hinges_qn_4"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="hinges_qn_4-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="hinges_qn_4-na"
                                                        name="hinges_qn_4"
                                                        v-model="baeSystemsReport.hinges_qn_4"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="hinges_qn_4-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-control-label">
                                                Are the hinges made from fire rated materials?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="hinges_qn_5-yes"
                                                        name="hinges_qn_5"
                                                        v-model="baeSystemsReport.hinges_qn_5"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="hinges_qn_5-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="hinges_qn_5-no"
                                                        name="hinges_qn_5"
                                                        v-model="baeSystemsReport.hinges_qn_5"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="hinges_qn_5-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="hinges_qn_5-na"
                                                        name="hinges_qn_5"
                                                        v-model="baeSystemsReport.hinges_qn_5"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="hinges_qn_5-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div class="form-group border-top">
                                        <h2 class="mt-4">Door Closers</h2>

                                        <div class="form-group">
                                            <label class="form-control-label">
                                                Open the door to 5 degrees or 75mm. Does it close fully and engage with the latch if fitted?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="closers_qn_1-yes"
                                                        name="closers_qn_1"
                                                        v-model="baeSystemsReport.closers_qn_1"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="closers_qn_1-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="closers_qn_1-no"
                                                        name="closers_qn_1"
                                                        v-model="baeSystemsReport.closers_qn_1"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="closers_qn_1-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="closers_qn_1-na"
                                                        name="closers_qn_1"
                                                        v-model="baeSystemsReport.closers_qn_1"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="closers_qn_1-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-control-label">
                                                Is the closer correctly attached to the door and frame?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="closers_qn_2-yes"
                                                        name="closers_qn_2"
                                                        v-model="baeSystemsReport.closers_qn_2"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="closers_qn_2-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="closers_qn_2-no"
                                                        name="closers_qn_2"
                                                        v-model="baeSystemsReport.closers_qn_2"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="closers_qn_2-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="closers_qn_2-na"
                                                        name="closers_qn_2"
                                                        v-model="baeSystemsReport.closers_qn_2"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="closers_qn_2-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-control-label">
                                                Is the closer free from damage and oil leakage?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="closers_qn_3-yes"
                                                        name="closers_qn_3"
                                                        v-model="baeSystemsReport.closers_qn_3"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="closers_qn_3-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="closers_qn_3-no"
                                                        name="closers_qn_3"
                                                        v-model="baeSystemsReport.closers_qn_3"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="closers_qn_3-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="closers_qn_3-na"
                                                        name="closers_qn_3"
                                                        v-model="baeSystemsReport.closers_qn_3"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="closers_qn_3-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-control-label">
                                                Does the closer hold the door in line with the frame and intumescent seal?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="closers_qn_4-yes"
                                                        name="closers_qn_4"
                                                        v-model="baeSystemsReport.closers_qn_4"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="closers_qn_4-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="closers_qn_4-no"
                                                        name="closers_qn_4"
                                                        v-model="baeSystemsReport.closers_qn_4"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="closers_qn_4-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="closers_qn_4-na"
                                                        name="closers_qn_4"
                                                        v-model="baeSystemsReport.closers_qn_4"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="closers_qn_4-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-control-label">
                                                If hung in pairs, do they close in line if both opened and released together?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="closers_qn_5-yes"
                                                        name="closers_qn_5"
                                                        v-model="baeSystemsReport.closers_qn_5"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="closers_qn_5-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="closers_qn_5-no"
                                                        name="closers_qn_5"
                                                        v-model="baeSystemsReport.closers_qn_5"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="closers_qn_5-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="closers_qn_5-na"
                                                        name="closers_qn_5"
                                                        v-model="baeSystemsReport.closers_qn_5"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="closers_qn_5-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div class="form-group border-top">
                                        <h2 class="mt-4">Hold Open Devices</h2>

                                        <div class="form-group">
                                            <label class="form-control-label">
                                                Is the device electronically powered?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="hold_open_qn_1-yes"
                                                        name="hold_open_qn_1"
                                                        v-model="baeSystemsReport.hold_open_qn_1"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="hold_open_qn_1-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="hold_open_qn_1-no"
                                                        name="hold_open_qn_1"
                                                        v-model="baeSystemsReport.hold_open_qn_1"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="hold_open_qn_1-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="hold_open_qn_1-na"
                                                        name="hold_open_qn_1"
                                                        v-model="baeSystemsReport.hold_open_qn_1"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="hold_open_qn_1-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-control-label">
                                                Does the hold open device release the door when required?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="hold_open_qn_2-yes"
                                                        name="hold_open_qn_2"
                                                        v-model="baeSystemsReport.hold_open_qn_2"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="hold_open_qn_2-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="hold_open_qn_2-no"
                                                        name="hold_open_qn_2"
                                                        v-model="baeSystemsReport.hold_open_qn_2"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="hold_open_qn_2-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="hold_open_qn_2-na"
                                                        name="hold_open_qn_2"
                                                        v-model="baeSystemsReport.hold_open_qn_2"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="hold_open_qn_2-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-control-label">
                                                Unable to verify locally
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="hold_open_qn_3-yes"
                                                        name="hold_open_qn_3"
                                                        v-model="baeSystemsReport.hold_open_qn_3"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="hold_open_qn_3-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="hold_open_qn_3-no"
                                                        name="hold_open_qn_3"
                                                        v-model="baeSystemsReport.hold_open_qn_3"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="hold_open_qn_3-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="hold_open_qn_3-na"
                                                        name="hold_open_qn_3"
                                                        v-model="baeSystemsReport.hold_open_qn_3"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="hold_open_qn_3-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div class="form-group border-top">
                                        <h2 class="mt-4">Lock and Latch</h2>

                                        <div class="form-group">
                                            <label class="form-control-label">
                                                Does the latch / lock hold the door firmly in place without rattling?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="lock_latch_qn_1-yes"
                                                        name="lock_latch_qn_1"
                                                        v-model="baeSystemsReport.lock_latch_qn_1"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="lock_latch_qn_1-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="lock_latch_qn_1-no"
                                                        name="lock_latch_qn_1"
                                                        v-model="baeSystemsReport.lock_latch_qn_1"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="lock_latch_qn_1-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="lock_latch_qn_1-na"
                                                        name="lock_latch_qn_1"
                                                        v-model="baeSystemsReport.lock_latch_qn_1"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="lock_latch_qn_1-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-control-label">
                                                Are all components correctly fitted and in full working order?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="lock_latch_qn_2-yes"
                                                        name="lock_latch_qn_2"
                                                        v-model="baeSystemsReport.lock_latch_qn_2"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="lock_latch_qn_2-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="lock_latch_qn_2-no"
                                                        name="lock_latch_qn_2"
                                                        v-model="baeSystemsReport.lock_latch_qn_2"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="lock_latch_qn_2-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="lock_latch_qn_2-na"
                                                        name="lock_latch_qn_2"
                                                        v-model="baeSystemsReport.lock_latch_qn_2"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="lock_latch_qn_2-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div class="form-group border-top">
                                        <h2 class="mt-4">Glass and Glazing</h2>

                                        <div class="form-group">
                                            <label class="form-control-label">
                                                Is the intumescent seal continuous and attached to the glass and bead?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="glass_glazing_qn_1-yes"
                                                        name="glass_glazing_qn_1"
                                                        v-model="baeSystemsReport.glass_glazing_qn_1"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="glass_glazing_qn_1-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="glass_glazing_qn_1-no"
                                                        name="glass_glazing_qn_1"
                                                        v-model="baeSystemsReport.glass_glazing_qn_1"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="glass_glazing_qn_1-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="glass_glazing_qn_1-na"
                                                        name="glass_glazing_qn_1"
                                                        v-model="baeSystemsReport.glass_glazing_qn_1"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="glass_glazing_qn_1-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-control-label">
                                                Are the glazing beads well attached to the frame and free from damage?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="glass_glazing_qn_2-yes"
                                                        name="glass_glazing_qn_2"
                                                        v-model="baeSystemsReport.glass_glazing_qn_2"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="glass_glazing_qn_2-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="glass_glazing_qn_2-no"
                                                        name="glass_glazing_qn_2"
                                                        v-model="baeSystemsReport.glass_glazing_qn_2"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="glass_glazing_qn_2-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="glass_glazing_qn_2-na"
                                                        name="glass_glazing_qn_2"
                                                        v-model="baeSystemsReport.glass_glazing_qn_2"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="glass_glazing_qn_2-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-control-label">
                                                Is the glass free from damage and cracking?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="glass_glazing_qn_3-yes"
                                                        name="glass_glazing_qn_3"
                                                        v-model="baeSystemsReport.glass_glazing_qn_3"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="glass_glazing_qn_3-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="glass_glazing_qn_3-no"
                                                        name="glass_glazing_qn_3"
                                                        v-model="baeSystemsReport.glass_glazing_qn_3"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="glass_glazing_qn_3-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="glass_glazing_qn_3-na"
                                                        name="glass_glazing_qn_3"
                                                        v-model="baeSystemsReport.glass_glazing_qn_3"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="glass_glazing_qn_3-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-control-label">
                                                Is the glass safety rated?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="glass_glazing_qn_4-yes"
                                                        name="glass_glazing_qn_4"
                                                        v-model="baeSystemsReport.glass_glazing_qn_4"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="glass_glazing_qn_4-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="glass_glazing_qn_4-no"
                                                        name="glass_glazing_qn_4"
                                                        v-model="baeSystemsReport.glass_glazing_qn_4"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="glass_glazing_qn_4-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="glass_glazing_qn_4-na"
                                                        name="glass_glazing_qn_4"
                                                        v-model="baeSystemsReport.glass_glazing_qn_4"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="glass_glazing_qn_4-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-control-label">
                                                Is the glass fire rated?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="glass_glazing_qn_5-yes"
                                                        name="glass_glazing_qn_5"
                                                        v-model="baeSystemsReport.glass_glazing_qn_5"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="glass_glazing_qn_5-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="glass_glazing_qn_5-no"
                                                        name="glass_glazing_qn_5"
                                                        v-model="baeSystemsReport.glass_glazing_qn_5"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="glass_glazing_qn_5-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="glass_glazing_qn_5-na"
                                                        name="glass_glazing_qn_5"
                                                        v-model="baeSystemsReport.glass_glazing_qn_5"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="glass_glazing_qn_5-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div class="form-group border-top">
                                        <h2 class="mt-4">Threshold Gap</h2>

                                        <div class="form-group">
                                            <label class="form-control-label">
                                                Is there a consistent gap under the door that allows it to swing without touching floor covering?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="threshold_gap_qn_1-yes"
                                                        name="threshold_gap_qn_1"
                                                        v-model="baeSystemsReport.threshold_gap_qn_1"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="threshold_gap_qn_1-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="threshold_gap_qn_1-no"
                                                        name="threshold_gap_qn_1"
                                                        v-model="baeSystemsReport.threshold_gap_qn_1"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="threshold_gap_qn_1-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="threshold_gap_qn_1-na"
                                                        name="threshold_gap_qn_1"
                                                        v-model="baeSystemsReport.threshold_gap_qn_1"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="threshold_gap_qn_1-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-control-label">
                                                If no drop seal is fitted, is the gap under the door 3mm or less?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="threshold_gap_qn_2-yes"
                                                        name="threshold_gap_qn_2"
                                                        v-model="baeSystemsReport.threshold_gap_qn_2"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="threshold_gap_qn_2-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="threshold_gap_qn_2-no"
                                                        name="threshold_gap_qn_2"
                                                        v-model="baeSystemsReport.threshold_gap_qn_2"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="threshold_gap_qn_2-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="threshold_gap_qn_2-na"
                                                        name="threshold_gap_qn_2"
                                                        v-model="baeSystemsReport.threshold_gap_qn_2"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="threshold_gap_qn_2-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-control-label">
                                                If a drop seal is fitted is the gap 10mm or less?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="threshold_gap_qn_3-yes"
                                                        name="threshold_gap_qn_3"
                                                        v-model="baeSystemsReport.threshold_gap_qn_3"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="threshold_gap_qn_3-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="threshold_gap_qn_3-no"
                                                        name="threshold_gap_qn_3"
                                                        v-model="baeSystemsReport.threshold_gap_qn_3"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="threshold_gap_qn_3-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="threshold_gap_qn_3-na"
                                                        name="threshold_gap_qn_3"
                                                        v-model="baeSystemsReport.threshold_gap_qn_3"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="threshold_gap_qn_3-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div class="form-group border-top">
                                        <h2 class="mt-4">Signage</h2>

                                        <div class="form-group">
                                            <div class="table-responsive">
                                                <table class="table table-condensed table-bordered">
                                                    <tbody>
                                                        <tr>
                                                            <td>Main Door:</td>
                                                            <td>
                                                                <label class="styled-checkbox">
                                                                    <input type="checkbox" v-model="baeSystemsReport.main_door_bool">
                                                                    <span class="checkmark"></span>
                                                                </label> 
                                                            </td>
                                                            <td>Closed:</td>
                                                            <td>
                                                                <label class="styled-checkbox">
                                                                    <input type="checkbox" v-model="baeSystemsReport.main_door_closed_bool">
                                                                    <span class="checkmark"></span>
                                                                </label> 
                                                            </td>
                                                            <td>Locked:</td>
                                                            <td>
                                                                <label class="styled-checkbox">
                                                                    <input type="checkbox" v-model="baeSystemsReport.main_door_locked_bool">
                                                                    <span class="checkmark"></span>
                                                                </label> 
                                                            </td>
                                                            <td>Automatic:</td>
                                                            <td>
                                                                <label class="styled-checkbox">
                                                                    <input type="checkbox" v-model="baeSystemsReport.main_door_auto_bool">
                                                                    <span class="checkmark"></span>
                                                                </label> 
                                                            </td>
                                                            <td>F/Escape:</td>
                                                            <td>
                                                                <label class="styled-checkbox">
                                                                    <input type="checkbox" v-model="baeSystemsReport.main_door_f_escape_bool">
                                                                    <span class="checkmark"></span>
                                                                </label> 
                                                            </td>
                                                            <td>Asset Tag:</td>
                                                            <td>
                                                                <label class="styled-checkbox">
                                                                    <input type="checkbox" v-model="baeSystemsReport.main_door_tag_bool">
                                                                    <span class="checkmark"></span>
                                                                </label> 
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>Second Door:</td>
                                                            <td>
                                                                <label class="styled-checkbox">
                                                                    <input type="checkbox" v-model="baeSystemsReport.second_door_bool">
                                                                    <span class="checkmark"></span>
                                                                </label> 
                                                            </td>
                                                            <td>Closed:</td>
                                                            <td>
                                                                <label class="styled-checkbox">
                                                                    <input type="checkbox" v-model="baeSystemsReport.second_door_closed_bool">
                                                                    <span class="checkmark"></span>
                                                                </label> 
                                                            </td>
                                                            <td>Locked:</td>
                                                            <td>
                                                                <label class="styled-checkbox">
                                                                    <input type="checkbox" v-model="baeSystemsReport.second_door_locked_bool">
                                                                    <span class="checkmark"></span>
                                                                </label> 
                                                            </td>
                                                            <td>Automatic:</td>
                                                            <td>
                                                                <label class="styled-checkbox">
                                                                    <input type="checkbox" v-model="baeSystemsReport.second_door_auto_bool">
                                                                    <span class="checkmark"></span>
                                                                </label> 
                                                            </td>
                                                            <td>F/Escape:</td>
                                                            <td>
                                                                <label class="styled-checkbox">
                                                                    <input type="checkbox" v-model="baeSystemsReport.second_door_f_escape_bool">
                                                                    <span class="checkmark"></span>
                                                                </label> 
                                                            </td>
                                                            <td>Asset Tag:</td>
                                                            <td>
                                                                <label class="styled-checkbox">
                                                                    <input type="checkbox" v-model="baeSystemsReport.second_door_tag_bool">
                                                                    <span class="checkmark"></span>
                                                                </label> 
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-control-label">
                                                Is all fire doors signage legible?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="all_fdoors_signage_legible-yes"
                                                        name="all_fdoors_signage_legible"
                                                        v-model="baeSystemsReport.all_fdoors_signage_legible"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="all_fdoors_signage_legible-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="all_fdoors_signage_legible-no"
                                                        name="all_fdoors_signage_legible"
                                                        v-model="baeSystemsReport.all_fdoors_signage_legible"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="all_fdoors_signage_legible-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="all_fdoors_signage_legible-na"
                                                        name="all_fdoors_signage_legible"
                                                        v-model="baeSystemsReport.all_fdoors_signage_legible"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="all_fdoors_signage_legible-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-control-label">
                                                Is the fire door signage correct as per the door schedule?
                                            </label>
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="fdoor_signage_correct-yes"
                                                        name="fdoor_signage_correct"
                                                        v-model="baeSystemsReport.fdoor_signage_correct"
                                                        class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="fdoor_signage_correct-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="fdoor_signage_correct-no"
                                                        name="fdoor_signage_correct"
                                                        v-model="baeSystemsReport.fdoor_signage_correct"
                                                        class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="fdoor_signage_correct-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="fdoor_signage_correct-na"
                                                        name="fdoor_signage_correct"
                                                        v-model="baeSystemsReport.fdoor_signage_correct"
                                                        class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="fdoor_signage_correct-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="form-group row d-flex align-items-center ">
                                            <label class="col-lg-4 form-control-label d-flex justify-content-lg-end"  for="signage_comments">
                                                Other Comment
                                            </label>
                                            <div class="col-lg-6 col-md-12">
                                                <textarea
                                                        class="form-control"
                                                        name="signage_comments"
                                                        maxlength="4000"
                                                        id="signage_comments"
                                                        rows="5"
                                                        v-model="baeSystemsReport.signage_comments"
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group border-top">
                                        <h2 class="mt-4">Actions</h2>

                                        <div class="form-group">
                                            <table class="table table-condensed table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>&nbsp;</th>
                                                        <th>Action Number</th>
                                                        <th>Part of door/door set</th>
                                                        <th>Issue</th>
                                                        <th>Action Priority</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(action, index) in baeSystemsReport.bae_systems_report_actions"
                                                        v-bind:key="index"
                                                    >
                                                        <td>
                                                            <a href="javascript:void(0)"
                                                                v-on:click="removeAction(index)"
                                                                class="report-action-remove-button">
                                                                <i class="fa fa-trash"></i>   
                                                            </a>   
                                                        </td>
                                                        <td style="width: 10%;">
                                                            {{ index + 1 }}
                                                        </td>
                                                        <td style="width: 20%;">
                                                            <input
                                                                    v-bind:name="'action_' + index + '_field_2'"
                                                                    v-bind:id="'action_' + index + '_field_2'"
                                                                    class="form-control"
                                                                    v-model="action.field_2"
                                                                    type="text"
                                                                    maxlength="255"
                                                            />
                                                        </td>
                                                        <td style="width: 40%;">
                                                            <input
                                                                    v-bind:name="'action_' + index + '_field_3'"
                                                                    v-bind:id="'action_' + index + '_field_3'"
                                                                    class="form-control"
                                                                    v-model="action.field_3"
                                                                    type="text"
                                                                    maxlength="4000"
                                                            />
                                                        </td>
                                                        <td style="width: 20%;">
                                                            <select
                                                                    v-bind:name="'action_' + index + '_field_4'"
                                                                    v-bind:id="'action_' + index + '_field_4'"
                                                                    class="form-control"
                                                                    v-model="action.field_4"
                                                            >
                                                                <option value="" disabled="disabled">Please select an option</option>
                                                                <option v-bind:value="priority" v-for="priority in actionPriorityOptions" v-bind:key="priority">{{ priority }}</option>
                                                            </select>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <a href="javascript:void(0)"
                                                v-on:click="addAction"
                                                class="btn btn-square btn-primary">
                                                Add action
                                            </a>
                                        </div>
                                    </div>

                                    <div class="form-group border-top">
                                        <h2 class="mt-4">Photographs</h2>

                                        <div class="form-group">
                                            <div class="row">
                                                <div class="col-sm-3 pb-3 entity-row-6"  style="margin-bottom: 10px;" v-for="(offlineImage, index) in baeSystemsReport.offline_images" v-bind:key="index">
                                                    <img v-bind:src="offlineImage.data" class="img-fluid">
                                                </div>
                                            </div>
                                            <div v-if="isImageUploading" style="background: #eaeaea; padding: 10px; margin: 10px 0;">
                                                    <h3><span class="fa fa-spin fa-circle-notch"></span>
                                                        Adding image... Please wait...</h3>
                                            </div>
                                            <label class="fileContainer">
                                                <span class="fa fa-camera"></span> Click to add an image
                                                <input type="file" accept="image/*" @change="onFileChange($event)">
                                            </label>
                                        </div>
                                    </div>

                                    <div class="alert alert-danger" v-if="isError">
                                        <p class="mb-0">
                                            <strong>The following fields have errors or are missing:</strong>
                                        </p>
                                        <ul class="mb-0 pl-3" v-if="errors.length > 0">
                                            <li v-for="error in errors" v-bind:key="error.field">
                                                <span v-if="error.field">{{ 'form.'+error.field }}<span v-if="error.message">: error.message</span></span>
                                                <span v-else-if="error.message">error.message</span>
                                            </li>
                                        </ul>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-sm-12">

                            <div class="form-group">
                                <button type="submit" class="btn btn-primary btn-square btn-lg w-100" :disabled="submitting">
                                    <span v-if="submitting">Submitting... <i class="fa fa-circle-notch fa-spin"></i></span>
                                    <span v-else>Save</span>
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </form>

    </div>
</template>

<style>
    .form-control {
        background: #fff !important;
    }
    .radio-as-buttons li {
        float: none;
        display: inline-block;
    }
    .fileContainer {
        float: none;
        margin-top: 10px;
    }
    .vdp-datepicker__calendar .selected {
        background: var(--primary-color) !important;
        color: #fff;
    }
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
        border: 1px solid var(--primary-color) !important;
    }
</style>

<script>
    import { required } from 'vuelidate/lib/validators';
    import ImageRotate from '@/components/mixins/ImageRotate.js';
    import Datepicker from 'vuejs-datepicker';

    var Compress = require('compress.js');
    var EXIF = require('exif-js');

    export default {
        mixins: [ImageRotate],
        data() {
            return {
                isEdit: false,
                isSubmitted: false,
                isError: false,
                errorHeader: 'error.invalidFields',
                errors: [],
                submitting: false,
                isImageUploading: false,
                baeSystemsReport: {
                    site_bae_systems_report_id: Math.floor(new Date().getTime() / 1000),
                    bae_systems_report_id: null,
                    door_identifier: null,
                    door_location: null,
                    door_zone_floor: null,
                    door_rating: null,
                    door_material: null,
                    door_manufacturer: null,
                    inspection_date: null,
                    inspector_name: null,
                    company: null,
                    comments: null,
                    leaf_qn_1: 'N/A',
                    leaf_qn_2: 'N/A',
                    leaf_qn_3: 'N/A',
                    frame_qn_1: 'N/A',
                    frame_qn_2: 'N/A',
                    frame_qn_3: 'N/A',
                    frame_qn_4: 'N/A',
                    frame_qn_5: 'N/A',
                    seals_qn_1: 'N/A',
                    seals_qn_2: 'N/A',
                    seals_qn_3: 'N/A',
                    seals_qn_4: 'N/A',
                    seals_qn_5: 'N/A',
                    hinges_qn_1: 'N/A',
                    hinges_qn_2: 'N/A',
                    hinges_qn_3: 'N/A',
                    hinges_qn_4: 'N/A',
                    hinges_qn_5: 'N/A',
                    closers_qn_1: 'N/A',
                    closers_qn_2: 'N/A',
                    closers_qn_3: 'N/A',
                    closers_qn_4: 'N/A',
                    closers_qn_5: 'N/A',
                    hold_open_qn_1: 'N/A',
                    hold_open_qn_2: 'N/A',
                    hold_open_qn_3: 'N/A',
                    lock_latch_qn_1: 'N/A',
                    lock_latch_qn_2: 'N/A',
                    glass_glazing_qn_1: 'N/A',
                    glass_glazing_qn_2: 'N/A',
                    glass_glazing_qn_3: 'N/A',
                    glass_glazing_qn_4: 'N/A',
                    glass_glazing_qn_5: 'N/A',
                    threshold_gap_qn_1: 'N/A',
                    threshold_gap_qn_2: 'N/A',
                    threshold_gap_qn_3: 'N/A',
                    main_door_bool: false,
                    main_door_closed_bool: false,
                    main_door_locked_bool: false,
                    main_door_auto_bool: false,
                    main_door_f_escape_bool: false,
                    main_door_tag_bool: false,
                    second_door_bool: false,
                    second_door_closed_bool: false,
                    second_door_locked_bool: false,
                    second_door_auto_bool: false,
                    second_door_f_escape_bool: false,
                    second_door_tag_bool: false,
                    all_fdoors_signage_legible: 'N/A',
                    fdoor_signage_correct: 'N/A',
                    signage_comments: null,
                    bae_systems_report_actions: [],
                    bae_systems_report_images: [],
                    pdf_link: null,
                    report_version: null,
                    offline_images: []
                },
                actionPriorityOptions: ['Priority 1 - 2hrs', 'Priority 2 - 2 days', 'Priority 3 - 7 days']
            }
        },
        validations: {
            baeSystemsReport: {
                door_identifier: { required },
                door_location: { required },
                door_zone_floor: { required }
            },
        },
        methods: {
            addAction() {
                this.baeSystemsReport.bae_systems_report_actions.push({
                    field_1: null,
                    field_2: null,
                    field_3: null,
                    field_4: null
                });
            },
            removeAction(index) {
                this.baeSystemsReport.bae_systems_report_actions.splice(index, 1);
            },
            onFileChange(e) {
                this.isImageUploading = true;
                var files = e.target.files || e.dataTransfer.files;
                if (!files.length) {
                    this.isImageUploading = false;
                    return;
                }
                var vm = this;
                EXIF.getData(files[0], function() {
                    var orientation = EXIF.getTag(this, "Orientation");
                    vm.createImage(files[0], orientation);
                });
            },
            createImage(file, orientation) {
                var compress = new Compress();
                var files = [file];

                compress.compress(files, {
                    size: 4, // the max size in MB, defaults to 2MB
                    quality: .6, // the quality of the image, max is 1,
                    maxWidth: 700, // the max width of the output image, defaults to 1920px
                    maxHeight: 700, // the max height of the output image, defaults to 1920px
                    resize: true, // defaults to true, set false if you do not want to resize the image width and height
                }).then(async (data) => {
                    var imgSrc = data[0].prefix + data[0].data;
                    var rotationDegrees = 0;
                    switch(orientation) {
                        case 3:
                            rotationDegrees = 180;
                            break;
                        case 6:
                            rotationDegrees = -90;
                            break;
                        case 8:
                            rotationDegrees = 90;
                            break;    
                    }

                    if(rotationDegrees != 0) {
                        await this.rotateImage(imgSrc, rotationDegrees).then(newDataUri => {
                            imgSrc = newDataUri;
                        }).catch(e => {
                            console.log(e);
                        });
                    }

                    this.baeSystemsReport.offline_images.push({
                        'data': imgSrc, 
                        'alt': data[0].alt, 
                        'orientation': orientation, 
                        'offline_image_id': this.$session.get('user_id').toString() + Math.floor(new Date().getTime() / 1000)
                    });
                    this.isImageUploading = false;
                });
            },
            getReport() {
                var vm = this;
                this.getDb(function onConnected(db) {
                    try {
                        var reportId = parseInt(vm.$route.params.id);
                        var objectStore = db.transaction('bae_systems_reports').objectStore('bae_systems_reports');
                        var storeRequest = objectStore.get(reportId);

                        storeRequest.onsuccess = function(event) {
                            let report = storeRequest.result;
                            
                            report.door_material = report.door_material !== undefined ? report.door_material : null;
                            report.door_manufacturer = report.door_manufacturer !== undefined ? report.door_manufacturer : null;
                            report.inspection_date = report.inspection_date !== undefined ? report.inspection_date : null;
                            report.inspector_name = report.inspector_name !== undefined ? report.inspector_name : null;
                            report.company = report.company !== undefined ? report.company : null;
                            report.frame_qn_5 = report.frame_qn_5 !== undefined ? report.frame_qn_5 : null;
                            report.main_door_bool = report.main_door_bool !== undefined ? report.main_door_bool : false;
                            report.main_door_closed_bool = report.main_door_closed_bool !== undefined ? report.main_door_closed_bool : false;
                            report.main_door_locked_bool = report.main_door_locked_bool !== undefined ? report.main_door_locked_bool : false;
                            report.main_door_auto_bool = report.main_door_auto_bool !== undefined ? report.main_door_auto_bool : false;
                            report.main_door_f_escape_bool = report.main_door_f_escape_bool !== undefined ? report.main_door_f_escape_bool : false;
                            report.main_door_tag_bool = report.main_door_tag_bool !== undefined ? report.main_door_tag_bool : false;
                            report.second_door_bool = report.second_door_bool !== undefined ? report.second_door_bool : false;
                            report.second_door_closed_bool = report.second_door_closed_bool !== undefined ? report.second_door_closed_bool : false;
                            report.second_door_locked_bool = report.second_door_locked_bool !== undefined ? report.second_door_locked_bool : false;
                            report.second_door_auto_bool = report.second_door_auto_bool !== undefined ? report.second_door_auto_bool : false;
                            report.second_door_f_escape_bool = report.second_door_f_escape_bool !== undefined ? report.second_door_f_escape_bool : false;
                            report.second_door_tag_bool = report.second_door_tag_bool !== undefined ? report.second_door_tag_bool : false;
                            report.all_fdoors_signage_legible = report.all_fdoors_signage_legible !== undefined ? report.all_fdoors_signage_legible : null;
                            report.fdoor_signage_correct = report.fdoor_signage_correct !== undefined ? report.fdoor_signage_correct : null;
                            report.signage_comments = report.signage_comments !== undefined ? report.signage_comments : null;

                            vm.baeSystemsReport = report;
                        };
                        storeRequest.onerror = function(e) {
                            console.log(e);
                        }
                    } catch (e) {
                        console.log(e);
                    }
                })
            },
            submit() {
                this.$v.$touch();
                if (!this.$v.$error) {
                    this.sendFormData();
                } else {
                    this.validationError();
                }
            },
            enableSubmitLoader() {
                this.submitting = true;
            },
            disableSubmitLoader() {
                this.submitting = false;
            },
            sendFormData() {
                this.enableSubmitLoader();

                var vm = this
                let request = new Promise((resolve, reject) => {
                    vm.getDb(function onConnectedGetDoorSets(db) {
                        var putRequest = db.transaction('bae_systems_reports', 'readwrite')
                            .objectStore('bae_systems_reports').put({
                                site_bae_systems_report_id: vm.baeSystemsReport.site_bae_systems_report_id,
                                bae_systems_report_id: vm.baeSystemsReport.bae_systems_report_id,
                                door_identifier: vm.baeSystemsReport.door_identifier,
                                door_location: vm.baeSystemsReport.door_location,
                                door_zone_floor: vm.baeSystemsReport.door_zone_floor,
                                door_rating: vm.baeSystemsReport.door_rating,
                                door_material: vm.baeSystemsReport.door_material,
                                door_manufacturer: vm.baeSystemsReport.door_manufacturer,
                                inspection_date: vm.baeSystemsReport.inspection_date,
                                inspector_name: vm.baeSystemsReport.inspector_name,
                                company: vm.baeSystemsReport.company,
                                comments: vm.baeSystemsReport.comments,
                                leaf_qn_1: vm.baeSystemsReport.leaf_qn_1,
                                leaf_qn_2: vm.baeSystemsReport.leaf_qn_2,
                                leaf_qn_3: vm.baeSystemsReport.leaf_qn_3,
                                frame_qn_1: vm.baeSystemsReport.frame_qn_1,
                                frame_qn_2: vm.baeSystemsReport.frame_qn_2,
                                frame_qn_3: vm.baeSystemsReport.frame_qn_3,
                                frame_qn_4: vm.baeSystemsReport.frame_qn_4,
                                frame_qn_5: vm.baeSystemsReport.frame_qn_5,
                                seals_qn_1: vm.baeSystemsReport.seals_qn_1,
                                seals_qn_2: vm.baeSystemsReport.seals_qn_2,
                                seals_qn_3: vm.baeSystemsReport.seals_qn_3,
                                seals_qn_4: vm.baeSystemsReport.seals_qn_4,
                                seals_qn_5: vm.baeSystemsReport.seals_qn_5,
                                hinges_qn_1: vm.baeSystemsReport.hinges_qn_1,
                                hinges_qn_2: vm.baeSystemsReport.hinges_qn_2,
                                hinges_qn_3: vm.baeSystemsReport.hinges_qn_3,
                                hinges_qn_4: vm.baeSystemsReport.hinges_qn_4,
                                hinges_qn_5: vm.baeSystemsReport.hinges_qn_5,
                                closers_qn_1: vm.baeSystemsReport.closers_qn_1,
                                closers_qn_2: vm.baeSystemsReport.closers_qn_2,
                                closers_qn_3: vm.baeSystemsReport.closers_qn_3,
                                closers_qn_4: vm.baeSystemsReport.closers_qn_4,
                                closers_qn_5: vm.baeSystemsReport.closers_qn_5,
                                hold_open_qn_1: vm.baeSystemsReport.hold_open_qn_1,
                                hold_open_qn_2: vm.baeSystemsReport.hold_open_qn_2,
                                hold_open_qn_3: vm.baeSystemsReport.hold_open_qn_3,
                                lock_latch_qn_1: vm.baeSystemsReport.lock_latch_qn_1,
                                lock_latch_qn_2: vm.baeSystemsReport.lock_latch_qn_2,
                                glass_glazing_qn_1: vm.baeSystemsReport.glass_glazing_qn_1,
                                glass_glazing_qn_2: vm.baeSystemsReport.glass_glazing_qn_2,
                                glass_glazing_qn_3: vm.baeSystemsReport.glass_glazing_qn_3,
                                glass_glazing_qn_4: vm.baeSystemsReport.glass_glazing_qn_4,
                                glass_glazing_qn_5: vm.baeSystemsReport.glass_glazing_qn_5,
                                threshold_gap_qn_1: vm.baeSystemsReport.threshold_gap_qn_1,
                                threshold_gap_qn_2: vm.baeSystemsReport.threshold_gap_qn_2,
                                threshold_gap_qn_3: vm.baeSystemsReport.threshold_gap_qn_3,
                                main_door_bool: vm.baeSystemsReport.main_door_bool,
                                main_door_closed_bool: vm.baeSystemsReport.main_door_closed_bool,
                                main_door_locked_bool: vm.baeSystemsReport.main_door_locked_bool,
                                main_door_auto_bool: vm.baeSystemsReport.main_door_auto_bool,
                                main_door_f_escape_bool: vm.baeSystemsReport.main_door_f_escape_bool,
                                main_door_tag_bool: vm.baeSystemsReport.main_door_tag_bool,
                                second_door_bool: vm.baeSystemsReport.second_door_bool,
                                second_door_closed_bool: vm.baeSystemsReport.second_door_closed_bool,
                                second_door_locked_bool: vm.baeSystemsReport.second_door_locked_bool,
                                second_door_auto_bool: vm.baeSystemsReport.second_door_auto_bool,
                                second_door_f_escape_bool: vm.baeSystemsReport.second_door_f_escape_bool,
                                second_door_tag_bool: vm.baeSystemsReport.second_door_tag_bool,
                                all_fdoors_signage_legible: vm.baeSystemsReport.all_fdoors_signage_legible,
                                fdoor_signage_correct: vm.baeSystemsReport.fdoor_signage_correct,
                                signage_comments: vm.baeSystemsReport.signage_comments,
                                bae_systems_report_actions: vm.baeSystemsReport.bae_systems_report_actions,
                                bae_systems_report_images: vm.baeSystemsReport.bae_systems_report_images,
                                pdf_link: vm.baeSystemsReport.pdf_link,
                                report_version: vm.baeSystemsReport.report_version,
                                offline_images: vm.baeSystemsReport.offline_images
                            });
                        putRequest.onsuccess = function(event) {
                            vm.submitSuccess({
                                success: true,
                                bae_systems_report_id: putRequest.result,
                            })
                        }
                        putRequest.onerror = function(event) {
                            alert("Unable to add data ");
                        }

                    })
                });
            },
            submitSuccess(response) {
                if (response.success) {
                    this.isSubmitted = true;
                    this.isError = false;
                    this.$router.push({ name: 'bae-systems-report-view', params: {action: 'view', id: response.bae_systems_report_id} })
                } else {
                    this.errorHeader = 'error.invalidFields';
                    this.errors = response.data.errors;
                    this.isError = true;
                }
            },
            submitError(error) {
                this.errorHeader = 'error.general';
                this.errors = [{'field': null, 'message': 'error.generalMessage'}];
                this.isError = true;
            },
            validationError() {
                this.errorHeader = 'error.invalidFields';
                this.errors = this.getErrors();
                this.isError = true;
            },
            isErrorField(field) {
                try {
                    if (this.getValidationField(field).$error) {
                        return true;
                    }
                } catch (error) {}

                return this.errors.some(el => el.field === field);
            },
            getErrors() {
                let errors = [];
                for (var field of Object.keys(this.baeSystemsReport)) {
                    try {
                        if (this.getValidationField(field).$error) {
                            errors.push({'field': field, 'message': null});
                        }
                    } catch (error) {}
                }
                return errors;
            },
            getFieldClasses(field) {
                return { 'is-invalid': this.isErrorField(field) }
            },
            getContainerClasses(field) {
                return { 'text-danger': this.isErrorField(field) }
            },
            getValidationField(field) {
                if (this.$v.baeSystemsReport[field]) {
                    return this.$v.baeSystemsReport[field];
                }
                throw Error('No validation for field ' + field);
            },
            onFieldBlur(field) {
                try {
                    this.getValidationField(field).$touch();
                    if (this.getValidationField(field).$error) {
                        if (!this.errors.some(el => el.field === field)) {
                            this.errors.push({'field': field, 'message': null});
                        }
                    } else {
                        this.errors = this.errors.filter(el => el.field !== field);
                    }
                } catch (error) {}
            },
            reload() {
                window.location = '';
            },
        },
        components: {
            Datepicker,
        },
        mounted () {
            const modulesData = this.$session.get('enabled_modules');
            if(!modulesData || modulesData.indexOf('BSR') === -1) {
                this.$router.push('/');
                return;
            }

            let reportId = this.$route.params.id;
            if (reportId) {
                this.isEdit = true;
                this.getReport();
            }
        },

    }
</script>